import moment from 'moment';

export default {
  computed: {
    /**
     * Used for providing filters to date range selector.
     * @return {object} - different date range filters (day, week, month, year etc)
     */
    customDateRanges() {
      const customDateRanges = {};
      customDateRanges[this.$t('frontend_dashboard_calender_filter_today')] = [
        moment(),
        moment()
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_yesterday')
      ] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_7_days')
      ] = [moment().subtract(6, 'days'), moment()];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_30_days')
      ] = [moment().subtract(29, 'days'), moment()];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_week')
      ] = [moment().startOf('week'), moment().endOf('week')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_week')
      ] = [
        moment()
          .subtract(1, 'week')
          .startOf('week'),
        moment()
          .subtract(1, 'week')
          .endOf('week')
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_month')
      ] = [moment().startOf('month'), moment().endOf('month')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_month')
      ] = [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month')
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_year')
      ] = [moment().startOf('year'), moment().endOf('year')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_year')
      ] = [
        moment()
          .subtract(1, 'year')
          .startOf('year'),
        moment()
          .subtract(1, 'year')
          .endOf('year')
      ];
      customDateRanges[
        `${this.$t('frontend_groovevideo_videos_date_picker_all_time')}`
      ] = [moment('19700101', 'YYYYMMDD'), moment()];
      return customDateRanges;
    }
  }
};
